import { Actor, Scene, ScreenElement, vec } from "excalibur";
import { Resources } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { playStart } from "../../util";
import { Hud } from "./hud";
import { TowerButton } from "./tower_button";
import { TowerCursor } from "./tower_cursor";
import { TowerSpec } from "./tower_specs";

const padding = 8;

export class TowerButtons extends ScreenElement {
    private towerCursor?: Actor = null;
    private buttons: TowerButton[] = [];
    private hud: Hud;
    
    constructor(private level: LevelOne, height: number) {
        super({
            pos: vec(padding, padding),
            height: height - padding * 2,
            width: 300,
        });
    }

    onInitialize() {
        this.hud = this.level.hud;

        this._engine.input.keyboard.on('press', (event) => {
            if (event.key === 'Escape') {
                this.towerCursor?.kill();
            }
        })
    }

    deselectTower() {
        this.towerCursor = null;
        for (const button of this.buttons) {
            button.setSelected(false);
        }

        this.hud.cursorOccupied = false;
    }

    setTowers(towerSpecs: TowerSpec[]) {
        let offset = 0;

        this.buttons = [];

        const diceSize = this.height / 2;

        let dieCounter = 0;

        for (let j = 0; j < 2; j++) {
            for (let i = 0; i < 3; i++) {
                if (dieCounter >= towerSpecs.length) {
                    continue;
                }

                const pos = vec(i * diceSize, j * diceSize);
                const numDice = dieCounter + 1;
                const towerSpec = towerSpecs[dieCounter];

                const button = new TowerButton(
                    this.level, pos.x, pos.y, diceSize, diceSize, towerSpec,
                    () => {
                        if (!this.level.hud.cursorOccupied && this.towerCursor == null) {
                            playStart(Resources.buttonClick);

                            this.towerCursor = new TowerCursor(
                                this.level,
                                towerSpec,
                            );

                            button.setSelected(true);

                            this.towerCursor.on('kill', () => this.deselectTower())
                            this.level.add(this.towerCursor);

                            this.level.hud.cursorOccupied = true;
                        }
                    }
                );

                button.on("pointerenter", (event) => {
                    this.hud.bottomBar.descriptionBox.setDescription(towerSpec.name, towerSpec.description, towerSpec.cost);
                });

                button.on("pointerleave", (event) => {
                    if (event.type === "move") {
                        this.hud.bottomBar.descriptionBox.clearDescription();
                    }
                });

                this.addChild(
                    button
                );

                this.buttons.push(button);

                dieCounter++;
            }
        }
    }
}